import React from 'react';

type StaticPageHeaderProps = {
  title: string;
};

export default function StaticPageHeader({ title }: StaticPageHeaderProps) {
  return (
    <>
      <section className="railSeoWrap__railTitle railSeoWrap__trainIndexTitle">
        <div className="makeFlex column">
          <h1 className="font22 latoBold appendBottom15 appendTop15">{title}</h1>
        </div>
        <div></div>
      </section>
    </>
  );
}
